import "angular";
import "angular-resource";
import AccountServiceModule from "../accountServiceModule/AccountServiceModule";
import AdviceService from "./AdviceService";
import AdviceFactory from "./AdviceFactory";
import TransactionAccessRetrService from "../layout/service/TransactionAccessRetrService";
import PrimaryPlanTxnAccessService from "../layout/service/primaryPlanTxnAccessService";
import InvestmentOverviewFactory from "../investmentOverview/InvestmentOverviewFactory";
import ClearIbbotsonCacheFactory from "../investmentOptions/ClearIbbotsonCacheFactory";

const AdviceServiceModule = angular.module('AdviceServiceModule', [
	'ngResource', 
	'AccountServiceModule'
])
	.service('adviceService', AdviceService)
	.factory('adviceFactory', AdviceFactory)
	.factory('TransactionAccessRetrService', TransactionAccessRetrService)
	.factory('PrimaryPlanTxnAccessService', PrimaryPlanTxnAccessService)
	.factory('investmentOverviewFactory', InvestmentOverviewFactory)
	.factory('clearIbbotsonCacheFactory', ClearIbbotsonCacheFactory);

export default AdviceServiceModule;
